/**
 * BUSCAR UN MÉDICO EN EL DIRECTORIO DEL MERCADO (Lissette 2026-10-15).
 *
 * *"También puedes agregar Dr. en el buscador, Dr. especialista, así como está
 * en el Mercado."* Nombre o especialidad + ZIP, y salen médicos reales con su
 * especialidad, NPI, dirección y teléfono (del mismo directorio que usa
 * HealthCare.gov). Se busca al pulsar Buscar (o Enter), no en cada letra: es
 * una pregunta a un servicio de fuera.
 *
 * Lo usan la ficha (llenar el formulario del médico) y el cotizador del
 * Mercado (¿está en la red de cada plan?).
 */
import { useState } from 'react';
import { buscarMedicosMercado } from '../api.js';
import { telefonoBonito, direccionDelMedico } from '../medicosDelMercado.js';

export default function BuscadorDeMedico({ zipInicial = '', onElegir, lang = 'es' }) {
  const es = lang !== 'en';
  const [q, setQ] = useState('');
  const [zip, setZip] = useState(String(zipInicial || '').slice(0, 5));
  const [resultados, setResultados] = useState(null); // null = todavía no se buscó
  const [buscando, setBuscando] = useState(false);
  const [aviso, setAviso] = useState('');

  const buscar = async () => {
    const texto = q.trim();
    if (texto.length < 2) { setAviso(es ? 'Escribe al menos 2 letras del nombre o la especialidad.' : 'Type at least 2 letters of the name or specialty.'); return; }
    if (!/^\d{5}$/.test(zip)) { setAviso(es ? 'Pon el ZIP (5 números) donde buscar.' : 'Enter the ZIP (5 digits) to search near.'); return; }
    setBuscando(true); setAviso('');
    const r = await buscarMedicosMercado({ q: texto, zip });
    setBuscando(false);
    setResultados(r.providers);
    if (r.error) {
      setAviso(es ? 'El directorio del Mercado no contestó ahora. Puedes escribir el médico a mano.' : 'The Marketplace directory did not answer. You can type the doctor by hand.');
    }
  };

  const enter = (e) => { if (e.key === 'Enter') { e.preventDefault(); buscar(); } };
  const caja = { fontSize: '.8rem', padding: '.45rem .6rem' };

  return (
    <div>
      <div style={{ display: 'flex', gap: '.4rem', flexWrap: 'wrap' }}>
        <input className="dkt-inp" style={{ ...caja, flex: '2 1 200px' }} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={enter}
          placeholder={es ? 'Nombre del doctor o especialidad (cardiología, Pérez…)' : 'Doctor name or specialty (cardiology, Smith…)'} />
        <input className="dkt-inp" style={{ ...caja, flex: '0 1 90px' }} value={zip} inputMode="numeric" maxLength={5}
          onChange={(e) => setZip(e.target.value.replace(/\D/g, '').slice(0, 5))} onKeyDown={enter} placeholder="ZIP" />
        <button type="button" onClick={buscar} disabled={buscando} className="dkt-btn-s" style={{ fontSize: '.75rem', padding: '.4rem .8rem', opacity: buscando ? 0.6 : 1 }}>
          {buscando ? (es ? 'Buscando…' : 'Searching…') : (es ? '🔎 Buscar' : '🔎 Search')}
        </button>
      </div>
      {!!aviso && <div style={{ fontSize: '.7rem', color: 'var(--c-amber,#ffb700)', marginTop: 4 }}>{aviso}</div>}
      {Array.isArray(resultados) && !aviso && (
        <div style={{ marginTop: '.4rem', maxHeight: 240, overflowY: 'auto', border: '1px solid var(--c-border,#1a3550)', borderRadius: 8 }}>
          {!resultados.length && (
            <div style={{ padding: '.55rem .7rem', fontSize: '.74rem', color: 'var(--c-text3,#45688a)' }}>
              {es ? 'No salió ninguno cerca de ese ZIP. Prueba con el apellido solo o con la especialidad.' : 'None found near that ZIP. Try the last name only or the specialty.'}
            </div>
          )}
          {resultados.map((m) => (
            <button key={m.npi} type="button" onClick={() => onElegir(m)}
              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '.45rem .7rem', border: 'none', borderBottom: '1px solid rgba(26,53,80,.45)',
                background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }}>
              <div style={{ fontSize: '.8rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
                🩺 {m.nombre}
                {m.distanciaMillas != null && <span style={{ fontWeight: 500, color: 'var(--c-text3,#45688a)', fontSize: '.68rem' }}> · {m.distanciaMillas} mi</span>}
                {m.aceptaPacientes === false && <span style={{ fontWeight: 600, color: 'var(--c-amber,#ffb700)', fontSize: '.68rem' }}> · {es ? 'no acepta pacientes nuevos' : 'not accepting new patients'}</span>}
              </div>
              <div style={{ fontSize: '.68rem', color: 'var(--c-text2,#7aa3c0)' }}>
                {[m.especialidades.slice(0, 2).join(', '), `NPI ${m.npi}`].filter(Boolean).join(' · ')}
              </div>
              <div style={{ fontSize: '.68rem', color: 'var(--c-text3,#45688a)' }}>
                {[direccionDelMedico(m), telefonoBonito(m.telefono)].filter(Boolean).join(' · ')}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
